import TransformIcon from '@mui/icons-material/Transform';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import HubIcon from '@mui/icons-material/Hub';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CodeIcon from '@mui/icons-material/Code';
import DialServiceText from '../components/DialServiceText';
import {useState} from "react";


let servData = [
    {
        title: "acePIM data transformator",
        text: "acePIM — is the powerful proprietary webtool which allows to perform complex multi-conditional mappings of data-models (taxonomies), transform product data, update and maintain product information, export product data to multiple sources, manage product feeds, get analytical and stats data and many more.\nContact us to request a demo!",
        longText: "Detailed text about Service number: 1"
    },
    {
        title: "Product feeds management",
        text: "We help brands to structurize their product data by creating a data feed in XML, JSON or CSV formats; automate feed updates and delivery; make the feed acessible by the users. Along with that we provide an “all inclusive” solution for delivering brand’s product data to  the online partners in their format.\nA structured and a regularly updated product feed automates product data flow, allows changes to be instantly delivered to partners and eliminates manual processing.",
        longText: "Detailed text about Service number: 2"
    },
    {
        title: "API connection with Icecat",
        text: "Icecat is a global product catalog and its data is used by thousands of online retailers, catalogs, comparison sites and marketing places. Having product data in Icecat boosts sales, increases brand awareness, online visibility and data citation.\nOur API connection with Icecat allows to connect a feed in 3 working days and ensures product data is smoothly delivered to Icecat. The data is then regularly updated in an automated way.",
        longText: "Detailed text about Service number: 3"
    },
    {
        title: "Taxonomy management",
        text: "Taxonomy shapes the content, helps better navigation and simplifies data flow. Being the ecommerce taxonomy experts with about 20 years of the field experience, we help brands, webshops, catalogs, comparison sites etc. create a topnotch up-to-date classification structure. It may be a tailor-made taxonomy or could be based on a global standard like: GS1, UNSPSC, ETIM.\nWe also do taxonomy mappings from source to target or vice versa ensuring there’s no data loss while data being transformed and delivered. There are many “taxonomy mapping projects” we’ve carried out in different PIMs resulting in successful data transfers.",
        longText: "Detailed text about Service number: 4"
    },
    {
        title: "Scraping for ecommerce",
        text: "With our expertise and sophisticated tooling we scrape even the most “hard nuts” websites online. It’s very helpful for brands to know how their product data is presented online on webshops or market places, whether it’s complete and accurate.\nWe offer a full-site scraping, micro-scraping or selected areas or pages. The output can be provided in CSV/XML/JSON/XLSX formats. The scraping can be done on a recurring basis. ",
        longText: "Detailed text about Service number: 5"
    },
    {
        title: "Consultancy services",
        text: "We provide consultancy and support to ecommerce players in different subjects. We assess and advise on product data management or taxonomy management. We can guide, supervise or lead data processing activites or parts of it.",
        longText: "Detailed text about Service number: 6"
    }
]

let servIcons: any =  {
    1: <TransformIcon fontSize={"large"} sx={{color: "#ffcc80"}}/>,
    2: <DynamicFeedIcon fontSize={"large"} sx={{color: "#ffcc80"}}/>,
    3: <HubIcon fontSize={"large"} sx={{color: "#ffcc80"}}/>,
    4: <AccountTreeIcon fontSize={"large"} sx={{color: "#ffcc80"}}/>,
    5: <CodeIcon fontSize={"large"} sx={{color: "#ffcc80"}}/>,
    6: <SupportAgentIcon fontSize={"large"} sx={{color: "#ffcc80"}}/>
}


export default function Services() {

    const [dialOpen, setDialOpen] = useState(false)

    const [servText, setServText] = useState<string>('')


    function handleDialOpen(servindx:number) {
        setServText(servData[servindx]['longText'])
        setDialOpen(true)
    }

    let allElems = servData.map((item: any, index: number) => {
        return <div key={index} className="services-one">
            <div>{servIcons[index+1]}</div>
            <div className="service-title">{item.title}</div>
            <div className="service-text">
                {/*{item.text}&nbsp;&nbsp;&nbsp;<span className="learn-more" onClick={() => {alert('clicked')}}>learn more</span>*/}
                {item.text}&nbsp;&nbsp;&nbsp;<span className="learn-more" onClick={() => { handleDialOpen(index) }}>learn more</span>
            </div>
        </div>
            })

    return (

        <>
            <DialServiceText
                open={dialOpen}
                setOpen={setDialOpen}
                text={servText}
            />

        <div className="services-block" id="services">
            {allElems}
        </div>
        </>
    )
}
